module.exports = __webpack_public_path__ + "static/media/recipe_category_11.aa61b7c8.png";